import { Box } from "@mui/material";
import APITokenRow from "./APITokenRow";

const GRID_COLS_ALL = "minmax(160px,2fr) minmax(130px,1.5fr) minmax(180px,2fr) minmax(90px,1fr) minmax(230px,2.5fr) minmax(120px,1.5fr) minmax(150px,1.5fr) 56px";
const GRID_COLS_SCOPED = "minmax(160px,2fr) minmax(180px,2fr) minmax(90px,1fr) minmax(230px,2.5fr) minmax(130px,1.5fr) minmax(150px,1.5fr) 56px";
const MIN_WIDTH_ALL = 1280;
const MIN_WIDTH_SCOPED = 1100;

export default function APITokenTable({ tokens, showAccountCol, onEdit, onDelete, onDisable, onEnable, onHistory }) {
  const gridCols = showAccountCol ? GRID_COLS_ALL : GRID_COLS_SCOPED;
  const minWidth = showAccountCol ? MIN_WIDTH_ALL : MIN_WIDTH_SCOPED;

  return (
    <Box
      sx={{
        border: "1px solid #d5d9e0",
        borderRadius: 2,
        overflowX: "auto",
        bgcolor: "#f6f7fa",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.65)",
      }}
    >
      <Box sx={{ minWidth }}>
        {/* Header row */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: gridCols,
            px: 1.5,
            py: 1.25,
            fontWeight: 700,
            fontSize: "0.8rem",
            letterSpacing: 0.2,
            textTransform: "uppercase",
            color: "#5f6878",
            borderBottom: "1px solid #d5d9e0",
            bgcolor: "#eceff3",
          }}
        >
          <Box>API Token Name</Box>
          {showAccountCol && <Box>Account</Box>}
          <Box>Assigned Workflows</Box>
          <Box>Status</Box>
          <Box>Token</Box>
          <Box>Created By</Box>
          <Box>Date</Box>
          <Box>Actions</Box>
        </Box>

        {/* Data rows */}
        {tokens.map((token) => (
          <APITokenRow
            key={token.id}
            token={token}
            showAccountCol={showAccountCol}
            gridCols={gridCols}
            onEdit={onEdit}
            onDelete={onDelete}
            onDisable={onDisable}
            onEnable={onEnable}
            onHistory={onHistory}
          />
        ))}

        {!tokens.length && (
          <Box sx={{ p: 2, color: "#7a8393" }}>No API Tokens Found</Box>
        )}
      </Box>
    </Box>
  );
}
